export default __webpack_public_path__ + "static/media/cancer_3x2_Cn.2db5df95.webp";